import { useCallback } from 'react';

export const useScrollToAnchor = () => {
    const scrollToAnchor = useCallback((anchorId) => {
        if (!anchorId) return;

        const element = document.getElementById(anchorId) || document.querySelector(`#${anchorId}`);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, []);

    return scrollToAnchor;
};